import { useState, useCallback, useEffect, RefObject } from "react";

export const useGlobalSoundTestShortcut = (
  inputRef: RefObject<HTMLInputElement>,
) => {
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (!inputRef.current) {
      return;
    }

    const pressed = new Set<string>();

    const handleKeyDown = (e: KeyboardEvent) => {
      pressed.add(e.key);

      if (e.shiftKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        openModal();
        pressed.clear();
      }
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      pressed.delete(e.key);
    };

    const el = inputRef.current;
    el.addEventListener("keydown", handleKeyDown);
    el.addEventListener("keyup", handleKeyUp);

    // eslint-disable-next-line consistent-return
    return () => {
      el.removeEventListener("keydown", handleKeyDown);
      el.removeEventListener("keyup", handleKeyUp);
    };
  }, [inputRef, openModal]);

  return { open, openModal, closeModal };
};
